import {createContext} from "react";

import type {ExportResult} from "./types.ts";

type CoeditingExport = Readonly<{
    /**
     * Prints the HTML of the document using the browser's print dialog.
     */
    print(): Promise<ExportResult>;
    /**
     * Downloads the document as a PDF. Uses the browser's native PDF
     * download functionality (similar to printing).
     */
    downloadPdf(): Promise<ExportResult>;
    /**
     * Downloads the document as a .docx file.
     */
    downloadDocx(): Promise<ExportResult>;
    /**
     * Exports the document as a PowerPoint file. Uses the LLM to convert
     * the document into slides. Only supported for some document types
     * (e.g. lesson plans and exit tickets).
     */
    downloadPptx(): Promise<ExportResult>;
    /**
     * Saves the document to Google Drive in .docx format.
     */
    saveDocxToGoogleDrive(): Promise<ExportResult>;
    /**
     * Saves the document to Google Slides in .pptx format. Only supported
     * for document types that can be converted to slides (same as
     * `downloadPptx`).
     */
    savePptxToGoogleSlides(): Promise<ExportResult>;
    /**
     * Saves the document to OneDrive in .docx format.
     */
    saveDocxToMicrosoftOneDrive(): Promise<ExportResult>;
    /**
     * Saves the document to OneDrive in .pptx format. Only supported
     * for document types that can be converted to slides (same as
     * `downloadPptx`).
     */
    savePptxToMicrosoftOneDrive(): Promise<ExportResult>;
    /**
     * Saves a version of the document as a Google Form. Uses the LLM to
     * convert the document into a form with questions. Only supported for
     * some document types (e.g. multiple-choice quizzes).
     */
    saveToGoogleForms(): Promise<ExportResult>;
    /**
     * Saves a version of the document as a Blooket question set.
     */
    saveToBlooket(): Promise<ExportResult>;
}>;

export const CoeditingExportContext = createContext<CoeditingExport>({
    print() {
        return Promise.resolve({ok: false});
    },
    downloadPdf() {
        return Promise.resolve({ok: false});
    },
    downloadDocx() {
        return Promise.resolve({ok: false});
    },
    downloadPptx() {
        return Promise.resolve({ok: false});
    },
    saveDocxToGoogleDrive() {
        return Promise.resolve({ok: false});
    },
    savePptxToGoogleSlides() {
        return Promise.resolve({ok: false});
    },
    saveDocxToMicrosoftOneDrive() {
        return Promise.resolve({ok: false});
    },
    savePptxToMicrosoftOneDrive() {
        return Promise.resolve({ok: false});
    },
    saveToGoogleForms() {
        return Promise.resolve({ok: false});
    },
    saveToBlooket() {
        return Promise.resolve({ok: false});
    },
});
